/**
 * Shared semantics with backend `weeklyCalorieTargets.ts` (duplicate for frontend bundle).
 */
export const WEEKDAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'] as const;
export type WeekdayKey = (typeof WEEKDAY_KEYS)[number];

export const WEEKDAY_LABELS: Record<WeekdayKey, string> = {
  sun: 'Sunday',
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday',
};

export type WeeklyCalorieMap = Partial<Record<WeekdayKey, number>>;

export function dateKeyToWeekday(dateKey: string): WeekdayKey {
  const [y, m, d] = dateKey.split('-').map((x) => Number(x));
  if (!y || !m || !d) return 'sun';
  const dt = new Date(y, m - 1, d);
  return WEEKDAY_KEYS[dt.getDay()] ?? 'sun';
}

export function parseWeeklyCalorieTargets(raw: unknown): WeeklyCalorieMap {
  if (raw == null || typeof raw !== 'object' || Array.isArray(raw)) return {};
  const o = raw as Record<string, unknown>;
  const out: WeeklyCalorieMap = {};
  for (const k of WEEKDAY_KEYS) {
    const v = o[k];
    if (v == null || v === '') continue;
    const n = Math.round(Number(v));
    if (!Number.isFinite(n)) continue;
    out[k] = Math.min(20000, Math.max(800, n));
  }
  return out;
}

export type CalorieProfileSlice = {
  calorieTarget?: number | null;
  maintenanceCalories?: number | null;
  useWeeklyCalorieTargets?: boolean | null;
  weeklyCalorieTargets?: unknown;
};

export function calorieTargetForDateKey(
  profile: CalorieProfileSlice | null | undefined,
  dateKey: string,
  fallback = 2200
): number {
  const base = profile?.calorieTarget ?? profile?.maintenanceCalories ?? fallback;
  if (!profile?.useWeeklyCalorieTargets) return base;
  const map = parseWeeklyCalorieTargets(profile.weeklyCalorieTargets);
  const dayVal = map[dateKeyToWeekday(dateKey)];
  if (dayVal != null) return dayVal;
  return base;
}
